import { Footer } from "../header/Footer";

export const WhitePage = ({ children }) => (
  <div className="bg-white z-50 top-14 fixed w-full h-lvh overflow-y-auto pb-14">
    <div className="container my-12 px-6 mx-auto">
      <section className="mb-4 text-gray-800">{children}</section>
    </div>
    <Footer />
  </div>
);
